import _ from 'lodash'
import KUuid from '../../core/utils/KUuid'
import { getColorByTheme } from '../../core/utils/KTheme'
import Wave from './Wave'
import { document } from 'ssr-window'

export default {
  name: 'KRipple',
  props: {
    disabled: Boolean,
    centered: Boolean,
    href: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ripples: [],
      ripple: null,
      waveStyles: null,
    }
  },
  computed: {},
  watch: {
    waveStyles(value) {
      if (value) {
        setTimeout(() => {
          this.waveStyles = null
        }, 1000)
      }
    },
  },
  methods: {
    startRipple($event) {
      const { disabled, centered } = this

      if (!disabled) {
        const size = this.getSize()
        let position = null

        if (centered) {
          position = this.getCenteredPosition(size)
        } else {
          position = this.getHitPosition($event, size)
        }

        const ripple = {
          waveStyles: this.applyStyles(position, size),
          uuid: KUuid(),
        }

        this.waveStyles = ripple.waveStyles

        this.ripples.push(ripple)
      }
    },
    applyStyles(position, size) {
      size += 'px'

      const styles = {
        ...position,
        width: size,
        height: size,
      }

      if (this.type) {
        styles.backgroundColor = getColorByTheme(this.type)
      } else if (this.color) {
        styles.backgroundColor = this.color
      }

      return styles
    },
    clearWave(uuid) {
      uuid ? (this.ripples = this.ripples.filter((ripple) => ripple.uuid !== uuid)) : (this.ripples = [])
    },
    getSize() {
      const { offsetWidth, offsetHeight } = this.$el

      return Math.round(Math.max(offsetWidth, offsetHeight))
    },
    getCenteredPosition(size) {
      const halfSize = -size / 2 + 'px'

      return {
        'margin-top': halfSize,
        'margin-left': halfSize,
      }
    },
    getHitPosition($event, elementSize) {
      const rect = this.$el.getBoundingClientRect()
      let top = $event.pageY
      let left = $event.pageX

      if ($event.type === 'touchstart') {
        top = $event.changedTouches[0].pageY
        left = $event.changedTouches[0].pageX
      }

      return {
        top: top - rect.top - elementSize / 2 - document.documentElement.scrollTop + 'px',
        left: left - rect.left - elementSize / 2 - document.documentElement.scrollLeft + 'px',
      }
    },
    waving(uuid) {
      return _.find(this.ripples, ['uuid', uuid]) !== null
    },
    renderWave(ripple) {
      const { uuid, waveStyles } = ripple

      const css = {
        'km-ripple-wave': true,
        'km-ripple-wave--centered': this.centered,
      }

      return (
        <Wave
          key={uuid}
          class={css}
          uuid={uuid}
          style={waveStyles}
          onWaveEnd={uuid => this.clearWave(uuid)}
        ></Wave>
      )
    },
  },
  render() {
    // let tag = this.tag || 'div'

    const css = {
      'km-ripple': true,
    }

    const events = {
      'mousedown': this.startRipple,
    }

    const attrs = {}

    if (this.href) {
      attrs.href = this.href
    }

    const data = {
      class: css,
      on: events,
      ref: 'ripple',
      attrs,
    }

    return (
      <div
        {...data}
      >
        {this.$slots.default}
        {
          _.map(this.ripples, ({ uuid, waveStyles }) => (
            <Wave
              key={uuid}
              class={{
                'km-ripple-wave': true,
                'km-ripple-wave--centered': this.centered,
              }}
              uuid={uuid}
              style={waveStyles}
              onWaveEnd={uuid => this.clearWave(uuid)}
            ></Wave>
          ))
        }
      </div>
    )
  },
}
